<template>
  <div class="wrapper position-relative">
    <div v-if="questions[currentQuestionIndex].isLast || currentPage == 'lastPage'">
      <top-three :lowestPrice="lowestPrice" :bestRating="bestRating" :bestAmazon="bestAmazon"
        :detailsContent="detailsContentLast" :explanations="finalExplanations" :shareable-link="shareableLink" @generate-share="generateShareLink" @copy-share="copyToClipboard" @reset="resetToStart">
        </top-three>
      <hr class="line-gap" />


      <h2>Weitere passende Heißluftfritteusen zu deiner Auswahl</h2>

      <div class="container-lg underQuestion col-md-8 pt-4">
        
        <div class="ml-2">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-black"> Sortierung </span>
          <select id="sortSelect" v-model="selectedSortOption" @change="sortProducts" name="sortSelect"
            class="spanSelectField form-select form-select-lg mb-1">
            <option value="Keine">Preis/Leistung</option>
            <option value="preisSortAuf">Preis aufsteigend</option>
            <option value="preisSortAb">Preis absteigend</option>
            <option value="frittierung_pred">Frittieren: Bewertung</option>
            <option value="frittierung_pred_pl">Frittieren: Preis/Leistung</option>
            <option value="vielseitigkeit_pred">Vielseitigkeit: Bewertung</option>
            <option value="vielseitigkeit_pred_pl">Vielseitigkeit: Preis/Leistung</option>
            <option value="mixed_pred">Beides: Bewertung</option>
            <option value="mixed_pl">Beides: Preis/Leistung</option>
          </select>
        </div>
        

        <div class="row g-0">
          <div
            v-for="product in additionalProducts"
            :key="'additional-product-' + getProductId(product)"
            class="col-lg-4 mb-4"
          >
            <div class="card" :class="{ 'is-flipped': isFlipped(getProductId(product)) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel
                  :key="'additional-carousel-' + getProductId(product)"
                  :product="product"
                  :instance-id="'additional-carousel-' + getProductId(product)"
                />
                <div class="card-body">
                  
                  <product-chart :product="product" />
                  
<div class="findingo-card-specs">
  <div class="findingo-card-spec">
    <span>
      <small>Maße in mm (LxBxH)</small>
      <strong
        v-if="
          Number(product.tiefe_mm) &&
          Number(product.breite_mm) &&
          Number(product.hoehe_mm)
        "
      >
        {{ product.tiefe_mm }}×{{ product.breite_mm }}×{{ product.hoehe_mm }}
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>

  <div class="findingo-card-spec">
    <span>
      <small>Fassungsvermögen</small>
      <strong v-if="Number(product.fassungsvermoegen_l)">
        {{ product.fassungsvermoegen_l }} Liter
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>

  <div class="findingo-card-spec">
    <span>
      <small>Temperaturbereich</small>
      <strong
        v-if="
          Number(product.temperatur_min_c) &&
          Number(product.temperatur_max_c)
        "
      >
        {{ product.temperatur_min_c }}°C - {{ product.temperatur_max_c }}°C
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>

  <div class="findingo-card-spec">
    <span>
      <small>Leistung</small>
      <strong v-if="Number(product.leistung_w)">
        {{ product.leistung_w }} Watt
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>
</div>
                </div>
                <button class="datasheet-button" @click="flipCard(getProductId(product))">
                  <i class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ formatPreis(product.preisAmazonNeu) }}
                            €</span><br />
                        </div>
                        <a :href="product.amazon_url" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod
                    :key="'datenblatt-' + getProductId(product)"
                    :product="product"
                    :instance-id="'datenblatt-' + getProductId(product)"
                  />
                  <button class="datasheet-button" @click="flipCard(getProductId(product))"><i
                      class="fa-solid fa-rotate-left icon-margin-right"></i>Zurück zur Übersicht</button>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-4" v-if="currentQuestionIndex > 0">
        <button class="datasheet-button" v-if="canLoadMoreProducts" @click="loadMoreProducts">
          Weitere Saugroboter laden
        </button>
      </div>
    </div>
    <div class="text-center" v-else-if="questions[currentQuestionIndex].currentQuestionIndex === 0">
      <div class="container topCont" style="padding-top:0px;">
        <div class="headScroll" ref="headScroll" :key="currentQuestionIndex">
          <div class="row align-items center">
            <div class="col-md-6">
              <transition appear name="slide-fade" mode="out-in">
                <form class="multisteps_form position-relative" @submit.prevent="nextQuestion"
                  :key="currentQuestionIndex">
                  <div v-if="questions[currentQuestionIndex]" :key="questions[currentQuestionIndex]">
                    <div class="question-title mt-4">
                      <h2 class=" question-title text-center px-2 py-1" >
                        {{ questions[currentQuestionIndex].question }}
                      </h2>
                    </div>
                  </div>
                  <div v-if="questions[currentQuestionIndex].isRadio" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex"
                      v-for="option in questions[currentQuestionIndex].options"
                      :key="'top-' + questions[currentQuestionIndex] + '-' + option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected:
                            questions[currentQuestionIndex].selectedOptionId ===
                            option.id,
                        },
                      ]">
                        <input class="form-check-input card-input" type="radio" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionId" @click="nextQuestionWithDelay" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isCheckbox" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex" v-for="option in questions[currentQuestionIndex].options"
                      :key="option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected: questions[
                            currentQuestionIndex
                          ].selectedOptionIds.includes(option.id),
                        },
                      ]">
                        <input class="" type="checkbox" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionIds" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isStepSlider">
                    <SliderSteps @update-slider="setSliderValue" />
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isSlider">
                    <div style="margin-top: 60px;">
                      <SliderComponent :minSize="currentMinSize" :maxSize="currentMaxSize" :value="currentMaxSize"
                        @update-slider="setSliderValues" />
                    </div>
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="back-button-wrapper" v-if="currentQuestionIndex > 0">
                      <button class="btn13" type="button" @click="goBack">Zurück</button>
                    </div>
                    <div class="back-button-wrapper"
                      v-if="questions[currentQuestionIndex].isCheckbox || questions[currentQuestionIndex].isSlider || questions[currentQuestionIndex].isStepSlider">
                      <button class="btn12-next" type="submit" :disabled="isNextButtonDisabled()">
                        Nächste Frage
                      </button>
                    </div>
                  </div>
                </form>
              </transition>
            </div>
            <div class="col-md-6" style="display: flex;
    align-items: center; margin-bottom: 20px;">
              <div>
                <div class="row">
                  <div class="col">
                    <blockquote class="speech-bubble" style="width: 80%; margin: 0 auto;">
                      <div class="container-infobox">
                        <p class="infoText" v-if="currentDescription" :key="currentDescription"
                          v-html="currentDescription">
                        </p>
                      </div>
                    </blockquote>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="position: relative;">
                    <img src="/wp-content/plugins/tv-berater/dingoTest.png" alt="Hund Bild" class="dingoPic">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
<div class="firstPage-info mb-4 text-start">
  <div class="card2 mt-4">
    
    <div class="header-container">
      <h1 class="firstPage">Heißluftfritteuse Kaufberatung & Vergleich</h1>
      <img class="logoMw" src="/wp-content/plugins/tv-berater/logo_small.png" width="160" height="80"
        alt="Findingo Logo">
    </div>

    <div class="intro-text">
      <p>
        Finde mit unserem interaktiven Heißluftfritteusen-Berater den passenden Airfryer für deinen Haushalt. Statt dich durch allgemeine Bestenlisten zu klicken, beantwortest du wenige Fragen zu deinem Alltag – und bekommst anschließend Modelle vorgeschlagen, die möglichst gut zu deinen Anforderungen passen.
      </p>

      <p>
        Wähle zuerst aus, wofür du deine Heißluftfritteuse hauptsächlich nutzen möchtest. Geht es dir vor allem um knusprige Pommes, Hähnchen, Gemüse und schnelle Alltagsgerichte? Suchst du einen kompakten Airfryer für eine kleine Küche, eine Heißluftfritteuse für zwei bis vier Personen oder ein größeres Modell für die Familie? Auf Basis deiner Antworten stellt dir der Kaufberater gezielte Folgefragen und grenzt passende Geräte Schritt für Schritt ein.
      </p>

      <p>
        Der Heißluftfritteusen-Vergleich berücksichtigt dabei wichtige Kriterien wie Fassungsvermögen in Litern, Bauart, Leistung, Temperaturbereich, Programme, Reinigung, Größe, Preis und Preis-Leistungs-Verhältnis. Auch Sonderfälle wie Doppelkammer-Heißluftfritteusen, Sichtfenster, spülmaschinenfeste Teile oder besonders vielseitige Funktionen werden einbezogen.
      </p>

      <p>Am Ende erhältst du individuelle Empfehlungen statt pauschaler Ranglisten: die günstigste passende Heißluftfritteuse, das leistungsstärkste Modell für deinen Einsatz und den Preis-Leistungs-Sieger. Zusätzlich zeigen wir dir weitere passende Airfryer, damit du die empfohlenen Modelle selbst vergleichen kannst.</p>

      <p>
        Beispiel: Du möchtest regelmäßig Pommes, Gemüse oder Hähnchen zubereiten, kochst meistens für zwei bis vier Personen und hast nur begrenzt Platz in der Küche. Vielleicht ist dir außerdem wichtig, dass die Reinigung einfach ist, der Korb genug Volumen bietet oder du zwei Speisen gleichzeitig zubereiten kannst. Brauchst du dafür wirklich eine große Doppelkammer-Heißluftfritteuse oder reicht ein kompakter Airfryer mit gutem Fassungsvermögen? Genau solche Unterschiede berücksichtigt der Kaufberater automatisch im Hintergrund.
      </p>
    </div>
  </div>

  <top-three-example v-if="lowestPrice && bestRating && bestAmazon" :lowestPrice="lowestPrice"
    :bestRating="bestRating" :bestAmazon="bestAmazon" />

  <div class="card2 mt-4">
    <div class="header-container">
      <h1 class="firstPage">Erkennen deiner Anforderungen und Nutzung</h1>
    </div>

    <div class="intro-text">
      <p>
        Ob für kleine Portionen, Familiengerichte, besonders knusprige Ergebnisse, einfache Reinigung, wenig Stellfläche oder möglichst viele Funktionen:
        Jede Nutzung stellt andere Anforderungen an eine Heißluftfritteuse. Genau hier setzt unsere Kaufberatung an.
        Die interaktive Sprechblase führt dich Schritt für Schritt zur passenden Auswahl – einfach, gezielt und individuell.
      </p>

      <p>
        Denn Heißluftfritteuse ist nicht gleich Heißluftfritteuse:
        Für eine Person reicht oft ein kompakter Airfryer, während Familien eher ein größeres Fassungsvermögen oder sogar eine Doppelkammer benötigen.
        Wer nur Pommes, Nuggets oder Gemüse zubereiten möchte, braucht nicht zwingend viele Zusatzprogramme.
        Wer dagegen auch backen, grillen, aufwärmen oder dörren möchte, sollte stärker auf Vielseitigkeit, Temperaturbereich und Ausstattung achten.
      </p>

      <p>
        Auch praktische Punkte wie Breite und Tiefe, entnehmbare Schüssel, Antihaftbeschichtung, spülmaschinenfeste Teile, Sichtfenster oder automatische Abschaltung können im Alltag entscheidend sein.
        Die Webanwendung erkennt solche Unterschiede und gewichtet die passenden Eigenschaften entsprechend – damit du nicht nur irgendeine Heißluftfritteuse findest, sondern ein Modell, das zu deiner Küche, deinen Portionen und deinen Kochgewohnheiten passt.
      </p>
    </div>
  </div>

  <MindMap></MindMap>

  <div class="details-wrapper">
    <details v-for="(content, index) in detailsContent" :key="index">
      <summary class="no_select" @click="handleSummaryClick(index)">
        {{ content.summary }}
      </summary>
      <div class="detail-desc no_select">
        {{ content.description }}
      </div>
    </details>
  </div>
</div>

    </div>
    <div v-else>
      <div class="container topCont" style="padding-top:0px;">
        <div class="headScroll" ref="headScroll">
          <div class="row align-items center">
            <div v-if="showProgress" class="col-12">
              <div class="progress-glass" :aria-valuenow="progressPercentage" aria-valuemin="0" aria-valuemax="100"
                role="progressbar">
                <span class="progress-glass__fill" :style="{ width: progressPercentage + '%' }">
                  <span class="sr-only">{{ progressPercentage }} %</span>
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <transition appear name="slide-fade" mode="out-in">
                <form class="multisteps_form position-relative" @submit.prevent="nextQuestion"
                  :key="currentQuestionIndex">
                  <div v-if="questions.length > 0">
                    <div v-if="questions[currentQuestionIndex]" :key="questions[currentQuestionIndex]">
                      <div class="question-title mt-4">
                        <h2 class="question-title text-center px-2 py-1">
                          {{ questions[currentQuestionIndex].question }}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div v-if="isLoader" class="overlay">
                    <div class="spinner-container">
                      <img src="/wp-content/plugins/tv-berater/logo_small.png" alt="Loading Icon"
                        class="rotating-image" />
                      <p class="loading-text">{{ loadingMessages[currentMessageIndex] }}</p>
                    </div>
                  </div>
                  <div v-if="questions[currentQuestionIndex].isRadio" class="rowX">

                    <div class="ite col-6 col-md-6 d-flex"
                      v-for="option in questions[currentQuestionIndex].options"
                      :key="currentQuestionIndex + '-' + option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected:
                            questions[currentQuestionIndex].selectedOptionId ===
                            option.id,
                        },
                      ]">
                        <input class="form-check-input card-input" type="radio" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionId" @click="nextQuestionWithDelay" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div v-else-if="questions[currentQuestionIndex].isCheckbox" class="rowX">
                    <div class="ite col-6 col-md-6 d-flex" v-for="option in questions[currentQuestionIndex].options"
                      :key="option.id">
                      <label :class="[
                        'card-label',
                        {
                          selected: questions[
                            currentQuestionIndex
                          ].selectedOptionIds.includes(option.id),
                        },
                      ]">
                        <input class="" type="checkbox" :value="option.id"
                          v-model="questions[currentQuestionIndex].selectedOptionIds" />
                        <div class="card-content text-center">
                          <img class="radio-icon" :src="option.iconPath" alt="Icon" width="192" height="108" />
                          <span>{{ option.label }}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isStepSlider">
                    <SliderSteps :bereich="questions[currentQuestionIndex].bereich" @update-slider="setSliderValue" />
                  </div>
                  <div v-else-if="questions[currentQuestionIndex].isSlider">
                    <SliderComponent @update-slider="setSliderValues" />
                  </div>
                  <div style="display: flex; justify-content: space-between">
                    <div class="back-button-wrapper" v-if="currentQuestionIndex > 0">
                      <button class="btn13-back" type="button" @click="goBack">Zurück</button>
                    </div>
                    <div class="back-button-wrapper"
                      v-if="questions[currentQuestionIndex].isCheckbox || questions[currentQuestionIndex].isSlider || questions[currentQuestionIndex].isStepSlider">
                      <button class="btn12-next" type="submit" :disabled="isNextButtonDisabled()">
                        Nächste Frage
                      </button>
                    </div>
                  </div>
                </form>
              </transition>
            </div>
            <div class="col-md-6" style="display: flex;
    align-items: center;">
              <div>
                <div class="row">
                  <div class="col">
                    <blockquote class="speech-bubble" style="width: 80%; margin: 0 auto;">
                      <div class="container-infobox typewriter">
                        <p class="infoText" v-if="currentDescription" :key="currentDescription"
                          v-html="currentDescription">
                        </p>
                      </div>
                    </blockquote>
                  </div>
                </div>
                <div class="row">
                  <div class="col" style="position: relative;">
                    <img src="/wp-content/plugins/tv-berater/dingoTest.png" alt="Hund Bild" class="dingoPic">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="questions[currentQuestionIndex].isLast"></div>
      <div v-else class="container-lg underQuestion col-md-8 pt-4">
        <div class="row row-fix">
          <div
            v-for="product in filteredProducts"
            :key="'product-' + getProductId(product)"
            class="col-lg-4 mb-4"
          >
            <div class="card" :class="{ 'is-flipped': isFlipped(getProductId(product)) }">
              <div class="card-front">
                <h5 class="card-title text-center mt-3 mx-5">
                  {{ product.amazonNamenSuche }}
                </h5>
                <pic-carousel
                  :key="'product-carousel-' + getProductId(product)"
                  :product="product"
                  :instance-id="'product-carousel-' + getProductId(product)"
                />
                <div class="card-body">
                  
                  <product-chart :product="product" />
                
<div class="findingo-card-specs">
  <div class="findingo-card-spec">
    <span>
      <small>Maße in mm (LxBxH)</small>
      <strong
        v-if="
          Number(product.tiefe_mm) &&
          Number(product.breite_mm) &&
          Number(product.hoehe_mm)
        "
      >
        {{ product.tiefe_mm }}×{{ product.breite_mm }}×{{ product.hoehe_mm }}
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>

  <div class="findingo-card-spec">
    <span>
      <small>Größe in Liter</small>
      <strong v-if="Number(product.fassungsvermoegen_l)">
        {{ product.fassungsvermoegen_l }} Liter
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>

  <div class="findingo-card-spec">
    <span>
      <small>Temperatur</small>
      <strong
        v-if="
          Number(product.temperatur_min_c) &&
          Number(product.temperatur_max_c)
        "
      >
        {{ product.temperatur_min_c }}°C - {{ product.temperatur_max_c }}°C
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>

  <div class="findingo-card-spec">
    <span>
      <small>Leistung</small>
      <strong v-if="Number(product.leistung_w)">
        {{ product.leistung_w }} W
      </strong>
      <strong v-else>keine Angabe</strong>
    </span>
  </div>
</div>
                </div>
                <button class="datasheet-button" @click="flipCard(getProductId(product))"><i
                    class="fa-solid fa-rotate-right icon-margin-right"></i> Daten aufklappen
                </button>
                <div class="card-footer">
                  <div class="footer-content d-flex justify-content-between">
                    <div class="shop-info">
                      <span class="no_click">Amazon.de</span>
                      <div class='' style='text-align: left; font-size: 12px; font-family:karla;'>
                        aktualisiert: {{ product.updated_time }}
                      </div>
                    </div>
                    <div class="amazon-info">
                      <div class="pb-2">
                        <div class="no_click pb-1">
                          <img class="shop-icon" src="./amazon_icon.png" alt="Amazon Logo" />
                          <span class="mr-2">| </span><span class="price"> {{ product.preisAmazonNeu }}€</span><br />
                        </div>
                        <a :href="product.amazon_url" target="_blank">
                          <button class="btn12 px-3 py-1">zum Angebot*</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-back">
                <div class="card-body">
                  <DatenblattMod
                    :key="'datenblatt-' + getProductId(product)"
                    :product="product"
                    :instance-id="'datenblatt-' + getProductId(product)"
                  />
                  <button class="datasheet-button" @click="flipCard(getProductId(product))">Zurück zur Übersicht</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pb-4" v-if="currentQuestionIndex > 0">
        <button class="datasheet-button" v-if="canLoadMoreProducts" @click="loadMoreProducts">
          Weitere Air Fryer laden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import SliderComponent from "/src/components/SliderComponent.vue";
import SliderSteps from "/src/components/SliderSteps.vue";
import ProductChart from "/src/components/ProductChart.vue";
import PicCarousel from "/src/components/PicCarousel.vue";
import DatenblattMod from "./components/DatenblattMod.vue";
import TopThreeDatenblattMod from "./components/TopThreeDatenblattMod.vue";
import TopThree from "./components/TopThree.vue";
import TypeWriter from "./components/TypeWriter.vue";
import Feedback from "/src/components/Feedback.vue";
import TypeWriterEffect from "/src/components/TypeWriterEffect.vue";
import TopThreeExample from "./components/TopThreeExample.vue";
import MindMap from "./components/MindMap.vue";


export default {
  components: {
    SliderComponent,
    SliderSteps,
    ProductChart,
    PicCarousel,
    DatenblattMod,
    TopThree,
    TopThreeExample,
    MindMap,
    TypeWriter,
    TypeWriterEffect,
    TopThreeDatenblattMod,
    Feedback,
  },

  created() {
    this.updateDescription();
    const urlParams = new URLSearchParams(window.location.search);
    const sharedResults = urlParams.get('r');

    if (sharedResults) {
      try {

        let base64String = sharedResults
          .replace(/-/g, '+')
          .replace(/_/g, '/');


        while (base64String.length % 4) {
          base64String += '=';
        }

        const jsonString = atob(base64String);
        const parsedData = JSON.parse(jsonString);

        if (parsedData && Array.isArray(parsedData.aq) && Array.isArray(parsedData.so)) {
          this.answeredQuestions = parsedData.aq;
          this.selectedOptions = parsedData.so;

          this.fetchResults();
          this.collectExplanations();
        } else {

          console.error("Ungültige Datenstruktur im geteilten Link.");
          this.resetToStart();
        }
      } catch (e) {
        console.error("Fehler beim Verarbeiten des geteilten Links:", e);
        this.resetToStart();
      }
    } else {
      this.currentPage = 'start';
    }
  },


  methods: {
        //Progress Functions start
    getNextIndexAlongPath(questionIndex) {
      const q = this.questions[questionIndex];
      if (!q || q.isLast) return null;
      const answeredPos = this.answeredQuestions.indexOf(q.id);
      if (answeredPos !== -1) {
        const selectedValue = this.selectedOptions[answeredPos];
        const opt = q.options.find(o => o.id === selectedValue);
        return this.questions.findIndex(x => x.id === opt?.nextQuestionId);
      }

      return this.questions.findIndex(
        x => x.id === q.options[0].nextQuestionId
      );
    },

    countPathLength(questionIndex) {
      let count = 0;
      let idx = questionIndex;
      while (idx !== null && idx !== -1) {
        count++;
        const next = this.getNextIndexAlongPath(idx);
        idx = next;
      }
      return count;
    },

    updateProgress() {
      if (this.currentPage === 'lastPage') {
        this.progressPercentage = 100;
        return;
      }
      const answered = this.answeredQuestions.length;         // schon fix
      const remaining = this.countPathLength(this.currentQuestionIndex);
      const total = answered + remaining;

      this.progressPercentage = Math.round((answered / total) * 100);
    },
    //Progress Functions end

    updateUrlWithResults() {
      const dataToShare = {
        aq: this.answeredQuestions,
        so: this.selectedOptions,
      };

      const jsonString = JSON.stringify(dataToShare);
      const base64String = btoa(jsonString);
      const urlSafeBase64 = base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      const newUrl = `${window.location.pathname}?r=${urlSafeBase64}`;

      window.history.pushState({ page: 'results' }, 'Ergebnisse', newUrl);
    },

    resetToStart() {
      this.currentPage = 'start';
      this.flippedCards = [];
      this.currentQuestionIndex = 0;
      this.nextQuestionIndex = null;
      this.answeredQuestions = [];
      this.selectedOptions = [];
      this.products = [];
      this.loadedProducts = [];
      this.productsPerLoad = 9;
      this.loadedProductIndex = 9;
      this.isLoader = false;
      this.feedback = '';
      this.message = '';
      this.selectedSortOption = "Keine";
      this.finalExplanations = [];
      this.shareableLink = null;


      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      this.updateDescription();
      this.scrollToTop();
    },


    fetchResults() {
      if (this.answeredQuestions.length === 0) {
        console.error("Keine Antworten zum Abrufen der Ergebnisse vorhanden.");
        return;
      }

      this.currentPage = 'loading';

      $.ajax({
        url: "/wp-content/plugins/airfryer-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: this.answeredQuestions,
          selectedOptions: this.selectedOptions,
          limit: this.getApiLimit(),
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
          this.currentPage = 'lastPage';

          this.updateUrlWithResults();
          // --- NEUER TEIL ENDE ---
        },
        error: (error) => {
          console.error("Fehler beim Abrufen der Daten:", error);
          this.currentPage = 'start';
        },
      });
    },
    
    generateShareLink() {
      const dataToShare = {
        aq: this.answeredQuestions,
        so: this.selectedOptions,
      };

      const jsonString = JSON.stringify(dataToShare);
      const base64String = btoa(jsonString);
      const urlSafeBase64 = base64String
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');

      const baseUrl = window.location.origin + window.location.pathname;
      this.shareableLink = `${baseUrl}?r=${urlSafeBase64}`;
    },

    getProductId(product) {
      return String(
        product?.id ??
        product?.asin ??
        product?.amazon_url ??
        product?.amazonNamenSuche ??
        ''
      );
    },

    getApiLimit() {
      // Etwas mehr laden, weil auf der Ergebnis-Seite die Top-Three-Produkte unten herausgefiltert werden.
      return this.loadedProductIndex + 3;
    },

    copyToClipboard(url) {
      if (url) {
        this.shareableLink = url;
      }
    },

    formatPreis(preis) {
      if (!preis) return '';
      return parseFloat(preis).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    sortProducts() {
      this.flippedCards = [];

      $.ajax({
        url: "/wp-content/plugins/airfryer-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: this.answeredQuestions,
          selectedOptions: this.selectedOptions,
          limit: this.getApiLimit(),
          sortOption: this.selectedSortOption,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
        },
        error: (error) => {
        },
      });
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    sendFeedback() {
      $.ajax({
        url: '/wp-content/plugins/airfryer-berater/get_feedback.php',
        method: 'POST',
        data: {
          feedback: this.feedback
        },
        dataType: 'json',
        success: (response) => {
          this.message = response.message;
          if (response.status === 'success') {
            this.feedback = '';
          }
        },
        error: (xhr, status, error) => {
          this.message = 'Es gab einen Fehler beim Senden des Feedbacks.';
        }
      });
    },

    updateDescription() {
      this.currentDescription = this.questions[this.currentQuestionIndex].tooltip;
      this.$nextTick(this.resetTypewriter);
    },
    flipCard(productId) {
      const id = String(productId);
      const cardIndex = this.flippedCards.indexOf(id);

      if (cardIndex === -1) {
        this.flippedCards.push(id);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },

    isFlipped(productId) {
      return this.flippedCards.includes(String(productId));
    },

    resetTypewriter() {
      const paragraphs = document.querySelectorAll(".typewriter > p");
      paragraphs.forEach(paragraph => paragraph.setAttribute("data-content", ""));
      this.startTypewriter();
    },
    startTypewriter() {
      const paragraphs = document.querySelectorAll(".typewriter > p");
      let currentLetter = 0;
      let currentParagraph = 0;
      const typeWriter = () => {
        if (currentParagraph >= paragraphs.length) return;
        const text = paragraphs[currentParagraph].textContent;

        if (currentLetter < text.length) {
          paragraphs[currentParagraph].setAttribute("data-content", text.slice(0, currentLetter + 1));
          currentLetter++;
        } else {
          currentParagraph++;
          currentLetter = 0;
        }

        setTimeout(typeWriter, currentLetter === text.length ? 500 : 25);
      };

      typeWriter();
    },
    loadMoreProducts() {
      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;
      this.loadedProductIndex += 9;
      $.ajax({
        url: "/wp-content/plugins/airfryer-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.getApiLimit(),
          sortOption: this.selectedSortOption,
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
    },
    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInRight animate__${delay}ms`;
    },

    initSlider() {
      if (!this.isSliderInitialized) {
        const sliderElement = this.$refs.slider77;
        noUiSlider.create(sliderElement, {
          start: [0],
          range: {
            min: 0,
            max: 100,
          },
        });
        this.isSliderInitialized = true;
      }
    },

    collectExplanations() {
      let explanations = [];

      this.answeredQuestions.forEach((questionId, index) => {
        const questionObj = this.questions.find(q => q.id === questionId);
        const selectedOptionId = this.selectedOptions[index];

        if (questionObj && !Array.isArray(selectedOptionId)) {
          // Radio
          const selectedOption = questionObj.options.find(opt => opt.id === selectedOptionId);
          if (selectedOption && selectedOption.explanation) {
            explanations.push(selectedOption.explanation);
          }
        } else if (questionObj && Array.isArray(selectedOptionId)) {
          // Checkbox(en) oder Slider
          selectedOptionId.forEach(optId => {
            const selectedOpt = questionObj.options.find(opt => opt.id === optId);
            if (selectedOpt && selectedOpt.explanation) {
              explanations.push(selectedOpt.explanation);
            }
          });
        }
      });

      // Jetzt das gesammelte Array in eine reaktive Variable schreiben
      this.finalExplanations = explanations;
    },

    nextQuestionWithDelay() {
      if (this.questions[this.currentQuestionIndex].needLoader) {
        this.isLoader = true;
        this.updateUrlWithResults();
        this.collectExplanations();
        this.startMessageRotation();
        setTimeout(() => {
          this.isLoader = false;
          clearInterval(this.messageInterval);
          this.currentMessageIndex = 0;
          this.nextQuestion();
          this.scrollToTop();

        }, 5000);
      }
      else {
        setTimeout(() => {

          this.nextQuestion();
          this.scrollToTop();

        }, 150);

      }
    },
    setSliderValues({ minSize, maxSize }) {
      this.minSize = minSize;
      this.maxSize = maxSize;
      this.questions[this.currentQuestionIndex].minSize = minSize;
      this.questions[this.currentQuestionIndex].maxSize = maxSize;
    },

    setSliderValue(value) {
      this.questions[this.currentQuestionIndex].selectedOptionId = value;
    },

    updateSizes(newSizes) {
      this.currentMinSize = this.minSize;
      this.currentMaxSize = this.maxSize;
    },

    nextQuestion() {
      this.loadedProductIndex = 9;
      this.flippedCards = [];
      let nextQuestionIndex = 0;
      let nextQuestionId = 0;
      if (this.currentQuestionIndex <= this.questions.length-1) {

        if (this.questions[this.currentQuestionIndex].isSlider) {
          this.selectedOptions.push([
            Number(this.questions[this.currentQuestionIndex].minSize),
            Number(this.questions[this.currentQuestionIndex].maxSize)
          ]);
          nextQuestionIndex = 14;
          nextQuestionId = 14;
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
        }


        else if (this.questions[this.currentQuestionIndex].isStepSlider) {
          const sliderValue = this.questions[this.currentQuestionIndex].selectedOptionId
          this.selectedOptions.push(Number(sliderValue));
          nextQuestionId = this.questions[this.currentQuestionIndex].options[sliderValue].nextQuestionId;
          nextQuestionIndex = this.questions.findIndex(
            (question) => question.id === nextQuestionId
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
        }

        else if (this.questions[this.currentQuestionIndex].isCheckbox) {

          this.selectedOptions.push(

            this.questions[this.currentQuestionIndex].selectedOptionIds
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);

          if (this.currentQuestionIndex === 6) {
            nextQuestionIndex = 15;
          } else if (this.currentQuestionIndex === 6) {
            nextQuestionIndex = 15;
          }

        }
        else if (!(this.questions[this.currentQuestionIndex].isCheckbox)) {
          const selectedOption = this.questions[
            this.currentQuestionIndex
          ].options.find(
            (option) =>
              option.id ===
              this.questions[this.currentQuestionIndex].selectedOptionId
          );
          nextQuestionId = selectedOption.nextQuestionId;
          nextQuestionIndex = this.questions.findIndex(
            (question) => question.id === nextQuestionId
          );
          this.answeredQuestions.push(this.questions[this.currentQuestionIndex].id);
          this.selectedOptions.push(

            this.questions[this.currentQuestionIndex].selectedOptionId
          );

        }

        this.currentQuestionIndex = nextQuestionIndex;
        this.nextQuestionIndex = null;
        this.updateDescription();
        this.updateUrlWithResults();
      } else {

      }


      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;
      $.ajax({
        url: "/wp-content/plugins/airfryer-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.getApiLimit(),
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
        },
        error: (jqXHR, textStatus, errorThrown) => {

        },
      });
      this.updateProgress();
      this.scrollToTop();

    },

    getExampleData() {
      const answeredQuestionsExample = [0,2,3,4,5,6]
      const selectedOptionsExample = [2,2,2,2,1,2]
      const demoLimit = 15

      $.ajax({
        url: '/wp-content/plugins/airfryer-berater/apiNewData.php',
        method: 'GET',
        data: {
          answeredQuestions: answeredQuestionsExample,
          selectedOptions: selectedOptionsExample,
          limit: demoLimit
        },
        dataType: 'json',
        success: response => {
          this.lowestPrice = response.lowPriceProduct
          this.bestRating = response.bestGamingProduct
          this.bestAmazon = response.bestAmazonProduct
        },
        error: err => {
          console.error('Demo-Daten konnten nicht geladen werden:', err)
        }
      })
    },

    goBack() {
      this.loadedProductIndex = 9;
      this.flippedCards = [];
      if (this.answeredQuestions.length === 1) {
        const previousQuestionIndex = this.answeredQuestions.pop();
        const previousQuestionId = this.questions[previousQuestionIndex].id;
        const previousQuestionIndexInArray = this.questions.findIndex(
          (question) => question.id === previousQuestionId
        );
        if (
          previousQuestionIndexInArray !== -1 &&
          previousQuestionIndexInArray !== -2
        ) {
          this.currentQuestionIndex = previousQuestionIndexInArray;
          this.nextQuestionIndex = null;
          this.questions[previousQuestionIndex].selectedOptionId =
            this.selectedOptions.pop();
        }
      }

      else {
        const previousQuestionId = this.answeredQuestions.pop();
        const previousQuestionIndexInArray = this.questions.findIndex(
          (question) => question.id === previousQuestionId
        );

        if (
          previousQuestionIndexInArray !== -1 &&
          previousQuestionIndexInArray !== -2
        ) {
          this.currentQuestionIndex = previousQuestionIndexInArray;
          this.questions[previousQuestionIndexInArray].selectedOptionId =
            this.selectedOptions.pop();
        }
      }
      this.updateDescription();
      this.updateProgress();

      var answeredQuestions = this.answeredQuestions;
      var selectedOptions = this.selectedOptions;

      $.ajax({
        url: "/wp-content/plugins/airfryer-berater/apiNewData.php",
        method: "GET",
        data: {
          answeredQuestions: answeredQuestions,
          selectedOptions: selectedOptions,
          limit: this.getApiLimit(),
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
          this.lowestPrice = response.lowPriceProduct;
          this.bestRating = response.bestGamingProduct;
          this.bestAmazon = response.bestAmazonProduct;
          this.totalProducts = response.totalProducts;
        },
        error: (error) => {
        },
      });
    },
    isNextButtonDisabled() {

      const selectedOptionId =
        this.questions[this.currentQuestionIndex].selectedOptionId;
      const lowerValue = this.questions[this.currentQuestionIndex].lowerValue;
      //const upperValue = this.questions[this.currentQuestionIndex].upperValue;
      const isLowerValue = true;
      const isHigherValue = true;
      const isSlider = this.questions[this.currentQuestionIndex].isSlider;
      const isStepSlider = this.questions[this.currentQuestionIndex].isStepSlider;
      const isCheckbox = this.questions[this.currentQuestionIndex].isCheckbox;

      if (isSlider || isCheckbox || isStepSlider || isLowerValue || isHigherValue) {

        return false;
      } else {
        return !selectedOptionId;
      }
    },

    startMessageRotation() {
      this.messageInterval = setInterval(() => {
        this.currentMessageIndex =
          (this.currentMessageIndex + 1) % this.loadingMessages.length;
      }, 2500);
    }
  },

  mounted() {
    // Hier muss noch currentstate und exampledata hin
    if (this.currentPage === 'start') {

      this.getExampleData()
    }
  },

  computed: {
    topThreeProductIds() {
      return new Set(
        [
          this.lowestPrice,
          this.bestRating,
          this.bestAmazon,
        ]
          .map(product => this.getProductId(product))
          .filter(id => id !== undefined && id !== null && id !== '')
      );
    },

    uniqueProducts() {
      const seen = new Set();

      return (this.products || []).filter(product => {
        const id = this.getProductId(product);

        if (!id || seen.has(id)) {
          return false;
        }

        seen.add(id);
        return true;
      });
    },

    filteredProducts() {
      return this.uniqueProducts.slice(0, this.loadedProductIndex);
    },

    additionalProducts() {
      return this.uniqueProducts
        .filter(product => !this.topThreeProductIds.has(this.getProductId(product)))
        .slice(0, this.loadedProductIndex);
    },

    canLoadMoreProducts() {
      const total = Number(this.totalProducts || 0);

      if (!total) {
        return false;
      }

      const isResultPage =
        this.currentPage === 'lastPage' ||
        this.questions[this.currentQuestionIndex]?.isLast;

      if (isResultPage) {
        const visibleTotal = Math.max(0, total - this.topThreeProductIds.size);
        return this.loadedProductIndex < visibleTotal;
      }

      return this.loadedProductIndex < total;
    },
  },

  data() {
    return {
      currentPage: 'start',
      flippedCards: [],
      currentQuestionIndex: 0,
      nextQuestionIndex: null,
      answeredQuestions: [],
      selectedOptions: [],
      products: [],
      totalProducts: 0,
      lowestPrice: null,
      bestRating: null,
      bestAmazon: null,
      loadedProducts: [],
      productsPerLoad: 9,
      loadedProductIndex: 9,
      isLoader: false,
      feedback: '',
      message: '',
      selectedSortOption: "Keine",
      finalExplanations: [],
      shareableLink: null,
      showProgress: true,
      currentMinSize: 9,
      currentMaxSize: 17,
      minSize: 9,
      maxSize: 17,

      loadingMessages: [
        "Daten werden analysiert!",
        "Empfehlungen generieren..",
      ],
      currentMessageIndex: 0,
      messageInterval: null,
      detailsContentLast: [
        {
          summary: "Wieso diese zu dir passen?",
          description:
            "Geschafft! Hier sind deine Top-3 Heißluftfritteusen-Empfehlungen nach Priorität: Der preisgünstigste Saugroboter, um mindestens deine Anforderungen zu erfüllen, das leistungsstärkste Modell für deinen Anwendungsbereich und der Preis-Leistungs-Sieger. Gleichzeitig siehst du ihre Bewertungen im Bereich Frottieren, Vielseitigkeit und bei größeren Frittiermengen. Diese können zwischen 1 und 10 liegen, währendem 10 absolute Spitzenklasse-Modelle repräsentiert. Weiter unten findest du weitere Modelle, die deine Kriterien erfüllen oder übertreffen – übersichtlich nach unserem berechneten Preis-Leistungs-Wert sortiert. Viel Spaß beim Entdecken!",
        },
      ],
detailsContent: [
  {
    summary: "Warum die Heißluftfritteusen-Kaufberatung unabhängig ist?",
    description:
      "Wir möchten dir nicht einfach irgendeine Heißluftfritteuse empfehlen, sondern ein Modell, das möglichst gut zu deinen persönlichen Anforderungen passt. Die Empfehlungen basieren auf technischen Produktdaten, Datenanalyse und Bewertungsmechanismen, ohne bestimmte Marken oder Hersteller grundsätzlich zu bevorzugen. Anders als viele Online-Shops stellen wir nicht einzelne Produkte gezielt in den Vordergrund, sondern versuchen anhand deiner Antworten passende Modelle für deinen Einsatzzweck zu finden.",
  },
  {
    summary: "Wie funktioniert die Heißluftfritteusen-Kaufberatung?",
    description:
      "Unsere Heißluftfritteusen-Kaufberatung führt dich durch mehrere kurze Fragen, zum Beispiel zur Haushaltsgröße, zum gewünschten Fassungsvermögen, zur Reinigung, zum Platzbedarf und dazu, was du hauptsächlich zubereiten möchtest. Die Fragen passen sich teilweise deinen Antworten an, damit eine möglichst individuelle Empfehlung entsteht. Ziel ist nicht automatisch die teuerste oder leistungsstärkste Heißluftfritteuse, sondern ein Modell, das gut zu deinem Alltag passt. Unsere Empfehlungen nutzen eine Kombination aus technischen Produktdaten, manueller Einordnung und datenbasierter Bewertung. Bitte prüfe wichtige Angaben wie Maße, Fassungsvermögen, Preis und Ausstattung zusätzlich direkt beim Anbieter, da Produktdaten sich ändern können und wir keine vollständige Gewähr für die Richtigkeit übernehmen können.",
  },
  {
    summary: "Werden meine Antworten gespeichert?",
    description:
      "Nein. Deine Antworten werden von diesem Tool nicht dauerhaft gespeichert und nicht für andere Zwecke weiterverarbeitet. Sie dienen nur während der Nutzung dazu, passende Heißluftfritteusen für dich zu filtern und zu empfehlen. Beim Schließen oder Zurücksetzen des Beraters gehen deine Eingaben verloren.",
  },
  {
    summary: "Warum zahlst du keinen Aufpreis?",
    description:
      "Die Nutzung der Kaufberatung ist für dich kostenlos. Wir verkaufen selbst keine Heißluftfritteusen oder andere Produkte, sondern verlinken auf externe Anbieter. Wenn du über einen unserer Links ein Produkt kaufst, erhalten wir möglicherweise eine kleine Provision. Für dich entstehen dadurch keine zusätzlichen Kosten. Diese Provision hilft dabei, die Kaufberatung weiter zu betreiben und zu verbessern. Trotzdem solltest du vor dem Kauf die Angaben auf der Anbieterseite prüfen, insbesondere Preis, Lieferumfang, Maße und technische Spezifikationen.",
  },
],



      openIndex: 0,

questions: [
  // FILTER / SCORE:
  // Hauptspalte: fassungsvermoegen_l
  // Datenqualität: sehr gut, 100% gefüllt
  // Nicht primär nutzen: anzahl_der_personen, weil nur schwach gefüllt
  // Logik:
  // 1 Person => kleine Geräte bevorzugen, z. B. ca. 2–4,5 l
  // 2 Personen => ca. 4–6,5 l bevorzugen
  // 3–4 Personen => ca. 6–8,5 l bevorzugen
  // 5+ Personen / Familie => ab ca. 8 l und/oder bauart = "Doppel" bevorzugen
  // Wichtig: Nicht hart ausschließen, sondern Fassungsvermögen passend gewichten.
  {
    currentQuestionIndex: 0,
    id: 0,
    question: 'Für wie viele Personen möchtest du meistens kochen?',
    tooltip:
      'Die Personenzahl hilft dabei, das passende Fassungsvermögen der Heißluftfritteuse abzuleiten. Für eine Person reicht meist ein kleineres Gerät, während Familien eher ein großes Modell oder eine Doppelkammer-Heißluftfritteuse benötigen.',
    options: [
      {
        id: 1,
        label: '1 Person',
        nextQuestionId: 2,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon_1.webp',
        explanation:
          'Für eine einzelne Person reicht meist ein kompaktes Modell. Es benötigt weniger Platz und ist für kleinere Portionen vollkommen ausreichend.',
      },
      {
        id: 2,
        label: '2 Personen',
        nextQuestionId: 2,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon_2.webp',
        explanation:
          'Für zwei Personen eignet sich meist ein mittleres Fassungsvermögen. Damit lassen sich typische Beilagen, Snacks oder kleinere Hauptgerichte gut zubereiten.',
      },
      {
        id: 3,
        label: '3–4 Personen',
        nextQuestionId: 2,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon_3.webp',
        explanation:
          'Für drei bis vier Personen sollte die Heißluftfritteuse mehr Garraum bieten, damit Pommes, Gemüse oder Hähnchen nicht in zu kleinen Mengen zubereitet werden müssen.',
      },
      {
        id: 4,
        label: '5+ Personen / Familie',
        nextQuestionId: 2,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon_4.webp',
        explanation:
          'Für Familien oder größere Portionen sind große Modelle oder Doppelkammer-Heißluftfritteusen besonders sinnvoll.',
      },
    ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: false,
    isCheckbox: false,
    isRadio: true,
    isLast: false,
    needLoader: false,
  },
  {
    currentQuestionIndex: 2,
    id: 2,
    question: 'Möchtest du zwei Speisen gleichzeitig zubereiten?',
    tooltip:
      'Doppelkammer-Heißluftfritteusen sind praktisch, wenn du zum Beispiel Pommes und Hähnchen gleichzeitig zubereiten möchtest. Wenn du eher einzelne Beilagen oder Snacks machst, reicht meist eine normale Einzelkammer.',
    options: [
            {
        id: 1,
        label: 'Ja, unbedingt mit 2 Körben',
        nextQuestionId: 3,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon_Dual.webp',
        explanation:
          'Dann ist eine Doppelkammer-Heißluftfritteuse besonders sinnvoll. So kannst du zwei Speisen getrennt garen und im besten Fall gleichzeitig fertig bekommen.',
      },
            {
        id: 2,
        label: 'Manchmal wäre das praktisch',
        nextQuestionId: 3,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_vielleicht_dual.webp',
        explanation:
          'Doppelkammer-Modelle werden leicht bevorzugt, aber gute Einzelkammer-Geräte bleiben weiterhin möglich.',
      },
      {
        id: 3,
        label: 'Nein, ich möchte nur einen Korb',
        nextQuestionId: 3,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon.webp',
        explanation:
          'Eine Einzelkammer ist meist kompakter, günstiger und für viele normale Alltagsgerichte vollkommen ausreichend.',
      },
    ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: false,
    isCheckbox: false,
    isRadio: true,
    isLast: false,
    needLoader: false,
  },
  {
    currentQuestionIndex: 3,
    id: 3,
    question: 'Wie wichtig sind dir schnelle und knusprige Ergebnisse?',
    tooltip:
      'Für schnelle und knusprige Ergebnisse sind vor allem Leistung, Maximaltemperatur und die Größe des Garraums relevant. Eine hohe Wattzahl allein entscheidet aber nicht alles.',
    options: [
        {
        id: 1,
        label: 'Nicht so wichtig',
        nextQuestionId: 4,
        iconPath: '/wp-content/plugins/heissluftfritteuse-berater/airfryer_schonend.avif',
        explanation:
          'Die Leistung wird weniger stark gewichtet. Dadurch können auch einfache oder günstigere Modelle gut passen.',
        },
        {
        id: 2,
        label: 'Normal wichtig',
        nextQuestionId: 4,
        iconPath: '/wp-content/plugins/heissluftfritteuse-berater/airfryer_normal.avif',
        explanation:
          'Leistung und Temperatur werden berücksichtigt, aber nicht zu streng bewertet.',
        },
        {
        id: 3,
        label: 'Sehr wichtig',
        nextQuestionId: 4,
        iconPath: '/wp-content/plugins/heissluftfritteuse-berater/airfryer_knusprig.avif',
        explanation:
          'Es werden leistungsstärkere Geräte mit hoher Maximaltemperatur bevorzugt. Das ist besonders bei Pommes, Fleisch und größeren Portionen sinnvoll.',
        },
    ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: true,
    isCheckbox: false,
    isRadio: false,
    isLast: false,
    needLoader: false,
    bereich: 'knusprig'
  },
  {
    currentQuestionIndex: 4,
    id: 4,
    question: 'Wie viel Platz hast du in der Küche?',
    tooltip:
      'Große Heißluftfritteusen und Doppelkammer-Geräte benötigen deutlich mehr Stellfläche. Wenn du wenig Platz hast, sollten kompaktere Modelle bevorzugt werden.',
    options: [
        {
        id: 1,
        label: 'Genug Platz, Gerät darf groß sein',
        nextQuestionId: 5,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_grosseFlaeche.webp',
        explanation:
          'Große Modelle und Doppelkammer-Geräte können stärker berücksichtigt werden, wenn sie gut zu deinen Anforderungen passen.',
        },
        {
        id: 2,
        label: 'Normal viel Platz',
        nextQuestionId: 5,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_MittlereFlaeche.webp',
        explanation:
          'Normale und mittelgroße Geräte passen gut. Sehr große Modelle werden nicht ausgeschlossen, aber auch nicht unnötig bevorzugt.',
      },  
      {
        id: 3,
        label: 'Sehr wenig Platz',
        nextQuestionId: 5,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_KleineFlaeche.webp',
        explanation:
          'Es werden kompaktere Geräte bevorzugt, die weniger Stellfläche auf der Arbeitsplatte benötigen.',
      },

    ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: false,
    isCheckbox: false,
    isRadio: true,
    isLast: false,
    needLoader: false,
  },

  {
  currentQuestionIndex: 5,
  id: 5,
  question: 'Was möchtest du mit dem Airfryer hauptsächlich machen?',
  tooltip:
    'Manche Airfryer sind eher für einfache Klassiker wie Pommes, Nuggets oder Gemüse gedacht. Andere Modelle bieten mehr Programme und Funktionen, zum Beispiel Backen, Grillen, Aufwärmen oder Dörren.',
  options: [
    {
      id: 1,
      label: 'Einfache Gerichte reichen mir',
      nextQuestionId: 6,
      iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Einfach.webp',
      explanation:
        'Dann muss dein Airfryer nicht besonders viele Zusatzfunktionen haben. Wichtig ist vor allem, dass er einfache Alltagsgerichte zuverlässig zubereitet.',
    },
    {
      id: 2,
      label: 'Auch Backen, Grillen oder Aufwärmen',
      nextQuestionId: 6,
      iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Vielseitig_Mittel.webp',
      explanation:
        'Dann achten wir auf etwas vielseitigere Geräte, die mehr können als nur klassische Pommes oder Snacks.',
    },
    {
      id: 3,
      label: 'Möglichst vielseitig – als kleiner Ofen-Ersatz',
      nextQuestionId: 6,
      iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Vielseitig_Sehr.webp',
      explanation:
        'Dann empfehlen wir bevorzugt Airfryer mit vielen Funktionen, Programmen und einem breiteren Einsatzbereich.',
    },
  ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: true,
    isCheckbox: false,
    isRadio: false,
    isLast: false,
    needLoader: true,
    bereich: "vielseitigkeit"
},

  // FILTER / SCORE:
  // Hauptspalten:
  // - leistung_w
  // - temperatur_max_c
  // - fassungsvermoegen_l
  //
  // Optional berechnen:
  // - leistung_pro_liter = leistung_w / fassungsvermoegen_l
  //
  // Datenqualität:
  // leistung_w ist gut gefüllt.
  // temperatur_max_c ist brauchbar, aber nicht vollständig.
  //
  // Logik:
  // Sehr wichtig => hohe Leistung, hohe Maximaltemperatur und gutes Verhältnis Leistung/Garraum bevorzugen
  // Normal wichtig => moderat gewichten
  // Nicht so wichtig => kaum gewichten, dadurch können günstigere/kompaktere Geräte besser abschneiden
    {
    currentQuestionIndex: 6,
    id: 6,
    question: 'Wie wichtig ist dir eine einfache Reinigung?',
    tooltip:
      'Bei Heißluftfritteusen ist die Reinigung ein wichtiger Alltagsfaktor. Spülmaschinengeeignete Teile, eine entnehmbare Schüssel und leicht zu reinigende Oberflächen machen die Nutzung deutlich angenehmer.',
    options: [
          {
        id: 1,
        label: 'Eher egal',
        nextQuestionId: 8,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Icon.webp',
        explanation:
          'Die Reinigung wird nur schwach berücksichtigt. Dadurch können auch einfache oder günstigere Modelle gut abschneiden.',
        },
        {
        id: 2,
        label: 'Wichtig, aber nicht entscheidend',
        nextQuestionId: 8,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Sauber2.webp',
        explanation:
          'Reinigungsfreundliche Modelle bekommen Vorteile, aber andere gute Geräte bleiben weiterhin möglich.',
      },  
      {
        id: 3,
        label: 'Sehr wichtig',
        nextQuestionId: 8,
        iconPath: '/wp-content/plugins/airfryer-berater/AirFryer_Sauber.webp',
        explanation:
          'Es werden besonders Modelle bevorzugt, die einfach zu reinigen sind und möglichst spülmaschinengeeignete Teile besitzen.',
      },


    ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: false,
    isCheckbox: false,
    isRadio: true,
    isLast: false,
    needLoader: true,
  },

  {
    currentQuestionIndex: 8,
    id: 8,
    question: '',
    options: [
      {
        id: 1,
        label: 'Günstigste Heißluftfritteuse für deine Bedürfnisse.',
      },
      {
        id: 2,
        label: 'Leistungsstärkste Heißluftfritteuse für deine Bedürfnisse.',
      },
      {
        id: 3,
        label: 'Bester Preis-/Leistungswert für deine Bedürfnisse.',
      },
    ],
    selectedOptionId: null,
    isSlider: false,
    isStepSlider: false,
    isCheckbox: false,
    isRadio: true,
    isLast: true,
    needLoader: false,
  },
]
    };
  },
};
</script>

<style scoped>

.wrapper {
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display: flex;
}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}



.card-back {

  transform: rotateY(180deg);
  position: absolute;
}

.label-data-front {
  color: #999
}


#form .typewriter-container {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  width: 40%;
  text-align: justify;
}

.question-text {
  font-size: 18px;
  margin-top: 10px;
}



h1 {
  font-size: 3rem;
  margin-bottom: 2rem;
}

#form .container-infobox {
  text-align: left;

}

.typewriter>* {
  color: transparent;
  position: relative;
}

.icon-margin-right {
  margin-right: 8px;
}

.typewriter>*::after {
  content: attr(data-content);
  color: var(--font-color, black);
  position: absolute;
  left: 0;
  top: 0;
}

#form blockquote.speech-bubble {
  --arrow-w: 0.5em;
  --arrow-h: 1em;
  --bubble-corners: 5px;
  --w: 12em;
  --border-size: 1.5px;
  --text-color: black;
  --bubble-color: white;
  --border-color: #daab4f;
}

#form blockquote.speech-bubble {
  text-align: center;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 15px;
  font-weight: None;
  color: var(--text-color);
  background: var(--bubble-color);
  padding: 1.5rem 2.5rem;
  border-radius: var(--bubble-corners);
  box-shadow: 0 0 0 var(--border-size) var(--border-color);
  line-height: none;
  border: None;
}

#form blockquote.speech-bubble.round {
  --bubble-corners: 1em;
}

#form blockquote.speech-bubble.circle {
  --bubble-corners: 100%;
  padding: 2em;
}





#form blockquote.speech-bubble.pop {
  animation-name: pop;
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
}

@keyframes pop {
  0% {
    transform: scale(0.8);
  }

  80% {
    transform: scale(1.1);
  }

  90% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes float-up {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(calc(-1 * var(--arrow-h)));
  }
}

@keyframes float-left {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(calc(-1 * var(--arrow-h)));
  }
}

@keyframes float-right {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(var(--arrow-h));
  }
}

@keyframes float-down {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(var(--arrow-h));
  }
}

#form .container.topCont {
  padding-top: 0px;
  background-color: #f4f8ff;
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

}

@media (min-width: 1500px) {
  .container.topCont {
    max-width: 1230px;
    padding-top: 0px;
  }
}

#form .dingoPic {
  max-height: 250px;
  width: 20%;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: -40px;
  margin-right: 5px;
}

@media (max-width: 576px) {
  #form .dingoPic {
    max-height: 350px;
    width: 20%;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 5px;
    margin-bottom: 0;
  }

}

.question-title {
  font-family: HKGroteskPro, serif !important;
}

#form .btn12 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
}

#form .btn12-next {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  padding: .6em 1em .4em !important;
}

#form .btn13-back {
  background-color: #0d6efd30;
  border: 1px solid #222222 !important;
  padding: .6em 1em .4em !important;
}

.back-button-wrapper {
  margin-top: 10px;
  margin-left: 15px;
  margin-bottom: 20px;
}

.card2 {
    width: 60%;
    margin: 1rem auto;
}

@media (min-width: 1024px) {
  .firstPage-info {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
  }
}



@media (min-width: 1024px) {
  .underQuestion {}
}

h1.firstPage {
  font-size: 2rem;
  margin-top: 10px;
  margin-bottom: 0.5rem;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-fade-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.slide-fade-leave-from {
  opacity: 1;
  transform: translateX(0);
  width: 100%;
}

.slide-fade-leave-to {
  opacity: 0;
  display: block;
  transform: translateX(0);
}

.slide-fade-leave-active {
  transition: opacity 0.5s ease;
}

.infoText {
  text-align: left;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-container {
  text-align: center;
  color: white;
}

.rotating-image {
  width: 100px;
  animation: spin 2s linear infinite;
}

.loading-text {
  font-size: 1.5rem;
  margin-top: 1rem;
  animation: fadeInOutFast 2.5s ease-in-out infinite;
}


@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeInOutFast {

  0%,
  15% {
    opacity: 0;
  }

  25%,
  75% {
    opacity: 1;
  }

  85%,
  100% {
    opacity: 0;
  }
}

.line-gap {
  margin-top: 0px;
  margin-bottom: 25px;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: .25;
  height: 1px;
  background-color: #ccc;
  width: 100%;
}

h2.question-title {
  font-weight: 500 !important;
  font-size: 37px !important;
  font-family: HKGroteskPro, serif !important;
}


@media (max-width: 768px) {
  h2.question-title {
    font-size: 30px !important;
    font-family: HKGroteskPro, serif !important;
    font-weight: 500 !important;
  }
}


@media (max-width: 480px) {
  h2.question-title {
    font-size: 30px !important;
    font-family: HKGroteskPro, serif !important;
    font-weight: 500 !important;
  }
}

.sort-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  /* Anordnung untereinander */
  align-items: center;
  /* Links ausrichten */
}

.sort-container label {
  margin-bottom: 0.2em;
  /* Geringer Abstand zwischen Label und Select-Box */
  font-weight: bold;
  /* Optional, um das Label hervorzuheben */
}

.sort-container select {
  padding: 0.25em 0.5em;
  /* Optional, für ein etwas schöneres Select-Feld */
}

.spanField {
  background-color: #b9d1ff;
  border-radius: 10px 10px 0 0;
}

.spanSelectField {
  border-radius: 0 10px 10px 10px;
  border-width: 1px;
}

.form-select {
  width: auto;
}

/*Progress Bar Custom */
.row>.progress-glass {
  padding-left: 0;
  padding-right: 0;
}

.progress-glass {
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 1.5rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  --fill-start: rgb(255 255 255 / 0%);
  --fill-end: rgb(155 220 134 / 23%);
}

.progress-glass__fill {
  display: block;
  height: 100%;
  background: linear-gradient(90deg,
      var(--fill-start) 0%,
      var(--fill-end) 100%);
  border-radius: inherit;
  transition: width 0.4s ease;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

h1.firstPage {
  font-size: 2rem;
  margin-top: 10px;
  margin-bottom: 0.5rem;
}

.card2 {
  width: 60%;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 40em;
  margin: 0 auto 1rem;
}

.logoMw {
  display: block;
}

@media (max-width: 768px) {
  .logoMw {
    display: none;
  }
}

.intro-text {
  text-align: left;
  max-width: 40em;

  margin: 0 auto 1.5rem;
  line-height: 1.6;
}


.detail-desc {
  text-align: left;
  padding: 0.5rem 1rem;
}

.image-container {
  text-align: center;
  margin: 1.5rem 0;
}

.image-container img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .card2 {
    width: 100%;
    padding: 0 1rem;
  }

  .header-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .logoMw {
    margin-top: 1rem;
    align-self: flex-start;
  }

  .intro-text {
    max-width: 100%;
  }
}


@media (min-width: 768px) and (max-width: 1023px) {

  .container-md.underQuestion {
    max-width: 720px;
    padding: 1rem;
  }


  .row.g-0>.col-12 {}

  .card2 {
    width: 80%;
    margin: 1rem auto;
  }

  .firstPage-info {
    width: 80%;
    margin: 1.5rem auto;
  }

  h2.question-title {
    font-size: 32px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {

  .col-md-6 {
    flex: 0 0 auto;
    width: 80%;
  }
}

.findingo-card-specs {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 38px;
  row-gap: 12px;

  width: fit-content;
  max-width: 100%;

  margin-left: auto;
  margin-right: auto;

  justify-items: start;
  align-items: start;

  text-align: left;
}

.findingo-card-spec {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 0;
  color: #273244;
  text-align: left;
}

.findingo-card-spec > span {
  display: block;
  min-width: 0;
  text-align: left;
}

.findingo-card-spec small {
  display: block;
  margin-top: 1px;
  color: var(--top-muted);
  font-size: 15px;
  line-height: 1.2;
  text-align: left;
}

.findingo-card-spec strong {
  display: block;
  color: #070708;
  line-height: 1.25;
  white-space: nowrap;
  text-align: left;
}
</style>